export default __webpack_public_path__ + "static/media/IMG_0097.0351ecf9.0351ecf9.jpg";